import React from "react";

export default function SectionTitle({ eyebrow, title, subtitle }) {
    return (
        <div className="mx-auto max-w-2xl text-center">
            {eyebrow ? (
                <div className="mb-3 text-xs font-semibold tracking-wider text-cyan-300/90">
                    {eyebrow}
                </div>
            ) : null}
            <h2 className="text-balance text-2xl font-semibold text-white sm:text-3xl">
                {title}
            </h2>
            {subtitle ? (
                <p className="mt-3 text-pretty text-sm leading-6 text-white/70 sm:text-base">
                    {subtitle}
                </p>
            ) : null}
        </div>
    );
}
